import React from 'react';
import { motion } from 'framer-motion';
import { usePermissionCheck } from '../../hooks/permissionHooks/usePermissionCheck';

const PermissionAwareButton = ({ 
  children, 
  permission, 
  fallbackForMainVendor = false,
  className = "",
  onClick,
  disabled = false,
  title,
  type = "button",
  ...props 
}) => {
  const { canPerform, isMainVendor, isAuthenticated } = usePermissionCheck();

  // Don't render if user is not authenticated
  if (!isAuthenticated) {
    return null;
  }

  // Check if user has the required permission
  const hasRequiredPermission = canPerform(permission?.module, permission?.action) || 
    (fallbackForMainVendor && isMainVendor);

  // Don't render if user doesn't have permission
  if (!hasRequiredPermission) {
    return null;
  }

  return (
    <motion.button
      whileHover={{ scale: disabled ? 1 : 1.02 }}
      whileTap={{ scale: disabled ? 1 : 0.98 }}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className}
      title={title}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default PermissionAwareButton; 